import { render, staticRenderFns } from "./HeaderTabMenuItem.vue?vue&type=template&id=0dbec5a2"
import script from "./HeaderTabMenuItem.vue?vue&type=script&lang=js"
export * from "./HeaderTabMenuItem.vue?vue&type=script&lang=js"
import style0 from "./HeaderTabMenuItem.vue?vue&type=style&index=0&id=0dbec5a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports